import { render, staticRenderFns } from "./workshopPanel.vue?vue&type=template&id=1396b6d7&scoped=true&"
import script from "./workshopPanel.vue?vue&type=script&lang=js&"
export * from "./workshopPanel.vue?vue&type=script&lang=js&"
import style0 from "./workshopPanel.vue?vue&type=style&index=0&id=1396b6d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396b6d7",
  null
  
)

export default component.exports